import {
  IPropertyConfiguration,
  PropertyType,
} from '~/client/graph/types.generated'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { getResourceLinkTarget } from '~/client/src/shared/resources/resourceLink'

export const formatPropertyType = (
  type: PropertyType | string | null | undefined,
  configuration?: Partial<IPropertyConfiguration> | null,
): string => {
  if (!type) return ''

  if (type === PropertyType.ResourceLink) {
    const target = getResourceLinkTarget(configuration)
    if (target) return target.localizedTypeLabel()
  }

  const typeMap: Record<string, string> = {
    [PropertyType.Text]: Localization.translator.resourcePropertyText,
    [PropertyType.Number]: Localization.translator.resourcePropertyNumber,
    [PropertyType.Select]: Localization.translator.resourcePropertySelect,
    [PropertyType.Hierarchy]: Localization.translator.resourcePropertyHierarchy,
    [PropertyType.Checkbox]: Localization.translator.resourcePropertyCheckbox,
    [PropertyType.Datetime]: Localization.translator.resourcePropertyDatetime,
    [PropertyType.ResourceLink]:
      Localization.translator.resourcePropertyRelation,
    [PropertyType.Rollup]: Localization.translator.resourcePropertyRollup,
    [PropertyType.ComputedField]:
      Localization.translator.resourcePropertyComputed,
    [PropertyType.User]: Localization.translator.resourcePropertyUser,
    [PropertyType.Company]: Localization.translator.resourcePropertyCompany,
    [PropertyType.File]: Localization.translator.resourcePropertyFile,
  }

  return typeMap[type] || type
}
